import events from '@layers/web/constants/events.ts'

export default defineNuxtPlugin((nuxtApp) => {
  const { TT_ID, ENABLE_TRACKING } = nuxtApp.$config.public

  /**
   * For list of events
   * @see https://ads.tiktok.com/help/article/standard-events-parameters
   */
  const initTT = () => {
    if (!TT_ID || !ENABLE_TRACKING) {
      return
    }

    /* eslint-disable */
    /* @ts-ignore */
    !(function (w, d, t) {
      /* @ts-ignore */
      w.TiktokAnalyticsObject = t
      /* @ts-ignore */
      const ttq = w[t] = w[t] || []
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'],
      /* @ts-ignore */
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }
      for (let i = 0; i < ttq.methods.length; i++) { ttq.setAndDefer(ttq, ttq.methods[i]) }
      /* @ts-ignore */
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) { ttq.setAndDefer(e, ttq.methods[n]) }
        return e
      /* @ts-ignore */
      }, ttq.load = function (e, n) {
        const i = 'https://analytics.tiktok.com/i18n/pixel/events.js'
        ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date(), ttq._o = ttq._o || {}, ttq._o[e] = n || {}
        const o = document.createElement('script')
        o.type = 'text/javascript', o.defer = !0, o.fetchPriority = 'low', o.src = i + '?sdkid=' + e + '&lib=' + t
        const a = document.getElementsByTagName('script')[0]
        /* @ts-ignore */
        a.parentNode.insertBefore(o, a)
      }
      ttq.load(TT_ID)
      ttq.enableCookie()
    }(window, document, 'ttq'))
    /* eslint-enable */
  }

  window.addEventListener(events.rbcsChange, (e) => {
    if (!(e instanceof CustomEvent)) {
      return
    }

    if (!e.detail?.userConsentStatus?.advertising) {
      return
    }

    initTT()
  })
})
